export enum enumDependencyState {
  PROVIDER_SEND_PENDING = 400,
  ACCEPTED = 600,
  REJECTED = 800,
}
